import React from "react";
// ANT DESIGN COMPONENTS
import { InputNumber } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// CONSTANTS
import { logicalPortMax, logicalPortMin } from "../../../constants/bankLogicalPort";

interface RestorePortFieldProps {
  /** Upper-case adapter protocol; it decides the range the port must fall in. */
  protocolUpper: string;
  value: number | null;
  onChange: (port: number | null) => void;
}

/**
 * The corrected-port input a restore offers when the bank's stored port is one
 * LiftCloud would refuse for its adapter.
 *
 * LobbyVision2 writes the port into a one-byte bank number, so a bank saved
 * before that limit existed can sit at a port the adapter cannot carry. The
 * server refuses to bring such a bank back unchanged, and accepts the same call
 * with a port in range, so the range shown here is the one the adapter enforces.
 */
function RestorePortField({ protocolUpper, value, onChange }: RestorePortFieldProps) {
  const [t] = useTranslation("global");
  const min = logicalPortMin(protocolUpper);
  const max = logicalPortMax(protocolUpper);

  return (
    <div>
      <p>{t("edgeManagement.banks.deleted.portPrompt", { min, max })}</p>
      <InputNumber
        min={min}
        max={max}
        precision={0}
        value={value}
        style={{ width: "100%" }}
        onChange={(next) => onChange(typeof next === "number" ? next : null)}
      />
    </div>
  );
}

export default RestorePortField;
